
// Chart theme and configuration utilities for growth charts

export interface ChartColorTheme {
  light: string;
  dark: string;
}

export interface ChartElementConfig {
  label: string;
  theme: ChartColorTheme;
}

export interface GrowthChartConfig {
  [key: string]: ChartElementConfig;
}

// Creates a chart configuration object for recharts
export const createChartConfig = (
  mainElementKey: string,
  mainElementLabel: string,
  mainElementTheme: ChartColorTheme
): GrowthChartConfig => {
  return {
    [mainElementKey]: {
      label: mainElementLabel,
      theme: mainElementTheme
    },
    original: {
      label: "Birth Measurement",
      theme: {
        light: "#f97316", // Orange
        dark: "#fb923c"
      }
    },
    average: {
      label: "Average",
      theme: {
        light: "#10b981", // Emerald
        dark: "#34d399"
      }
    }
  };
};
